/**
 * Чтение capabilities терминала (отдаёт backend в /terminals/{id} → resp.capabilities).
 *
 * Семантика:
 *   - true  — протокол явно умеет (показываем тоггл/блок);
 *   - false — протокол явно не умеет (скрываем);
 *   - null  — backend не знает (legacy / нет в ProtocolResolver) — fallback: показываем,
 *     иначе мы внезапно потеряем тогглы у легаси-терминалов после деплоя.
 */

const KNOWN_CAPABILITIES = ['preAuth', 'partialRefund', 'partialReversal', 'isPayoutOnly'];

/**
 * Должен ли быть виден целиком блок "Методы"?
 *
 * Скрываем только для protocols, которые явно payout-only (UnlimcoBank, FinStar,
 * NodaBank, TransCapitalBank). Для всех остальных — показываем.
 *
 * Fallback: если capabilities не пришли, показываем — лучше лишний блок чем
 * потерянная настройка у легаси-терминала.
 */
export function shouldShowMethodsBlock(terminal) {
    if (!terminal) return false;
    const caps = terminal.capabilities;
    if (!caps) return true;
    if (caps.isPayoutOnly === true) return false;
    return true;
}

/**
 * Разрешён ли конкретный capability-тоггл (preAuth/partialRefund/partialReversal)?
 *
 * Возвращает true если backend сказал что протокол умеет, ИЛИ если capabilities
 * нет вовсе (fallback). Не показываем только при явном false.
 */
export function capabilityAllows(terminal, capability) {
    if (!terminal) return false;
    const caps = terminal.capabilities;
    if (!caps) return true;
    if (!KNOWN_CAPABILITIES.includes(capability)) return true;
    return caps[capability] !== false;
}



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/TerminalEditing/capabilities.js